import React from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Table } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { ArrowLeft, CheckCircle, Truck } from 'lucide-react';
interface OutboundOrderProps {
  onBack: () => void;
}
export function OutboundOrder({
  onBack
}: OutboundOrderProps) {
  return <div className="space-y-6" data-id="element-1107">
      <div className="flex items-center justify-between" data-id="element-1108">
        <div className="flex items-center gap-4" data-id="element-1109">
          <Button variant="ghost" onClick={onBack} icon={<ArrowLeft size={20} data-id="element-1111" />} data-id="element-1110">
            Kembali
          </Button>
          <div data-id="element-1112">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-1113">
              Order Pengeluaran #OUT-2025-001
            </h1>
            <div className="flex items-center gap-2 mt-1" data-id="element-1114">
              <Badge variant="warning" data-id="element-1115">Picking in Progress</Badge>
              <span className="text-sm text-gray-500" data-id="element-1116">
                Tujuan: Pasar Induk Cipinang • Transporter: PT Pos Logistik
              </span>
            </div>
          </div>
        </div>
        <Button icon={<CheckCircle size={18} data-id="element-1118" />} data-id="element-1117">Selesai Loading</Button>
      </div>

      <Card title="Daftar Picking (Picking List)" data-id="element-1119">
        <Table columns={[{
        header: 'Lokasi Bin',
        accessor: 'bin'
      }, {
        header: 'Lot ID',
        accessor: 'lot'
      }, {
        header: 'Komoditas',
        accessor: 'item'
      }, {
        header: 'Qty (Ton)',
        accessor: 'qty'
      }, {
        header: 'Status',
        accessor: (item: any) => <Badge variant={item.status === 'Picked' ? 'success' : 'neutral'} data-id="element-1121">
                  {item.status}
                </Badge>
      }, {
        header: 'Aksi',
        accessor: () => <Button size="sm" variant="outline" data-id="element-1122">
                  Konfirmasi Pick
                </Button>
      }]} data={[{
        bin: 'A-01-02',
        lot: 'LOT-JKT-001',
        item: 'Beras Premium',
        qty: 10,
        status: 'Picked'
      }, {
        bin: 'A-01-03',
        lot: 'LOT-JKT-004',
        item: 'Beras Premium',
        qty: 5,
        status: 'Pending'
      }]} keyExtractor={i => i.lot} data-id="element-1120" />
      </Card>

      <div className="grid grid-cols-2 gap-6" data-id="element-1123">
        <Card title="Informasi Kendaraan" data-id="element-1124">
          <div className="space-y-2" data-id="element-1125">
            <div className="flex justify-between py-2 border-b" data-id="element-1126">
              <span className="text-gray-500" data-id="element-1127">Driver</span>
              <span className="font-medium" data-id="element-1128">Bambang Pamungkas</span>
            </div>
            <div className="flex justify-between py-2 border-b" data-id="element-1129">
              <span className="text-gray-500" data-id="element-1130">Plat Nomor</span>
              <span className="font-medium" data-id="element-1131">B 9988 XYZ</span>
            </div>
            <div className="flex justify-between py-2" data-id="element-1132">
              <span className="text-gray-500" data-id="element-1133">Jenis Truk</span>
              <span className="font-medium" data-id="element-1134">Wingbox (20 Ton)</span>
            </div>
          </div>
        </Card>
        <Card title="Dokumen Jalan" data-id="element-1135">
          <div className="flex flex-col gap-3" data-id="element-1136">
            <Button variant="outline" className="justify-between" data-id="element-1137">
              Surat Jalan (Delivery Order){' '}
              <span className="text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded" data-id="element-1138">
                Ready
              </span>
            </Button>
            <Button variant="outline" className="justify-between" data-id="element-1139">
              Gate Pass{' '}
              <span className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded" data-id="element-1140">
                Pending
              </span>
            </Button>
          </div>
        </Card>
      </div>
    </div>;
}